module.exports = __webpack_public_path__ + "static/media/sidebar-team-management-selected.ff0ebfa4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-team-management-selected.svg
// module id = 806
// module chunks = 0